/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.25.2 of "Consents"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */
import type { GetConsentResponse } from '../models/GetConsentResponse';
import type { GetConsentsResponse } from '../models/GetConsentsResponse';
import type { PutConsentResponse } from '../models/PutConsentResponse';
import type { UpdateConsent } from '../models/UpdateConsent';

import { clientOptionsFactory } from '../clientOptions';
import { apiClientRequest as __request } from '@api-client/base';
import type { ClientOptions } from '@api-client/base';

export class ConsentsService {

    /**
     * Get all consents.
     * Get all the consents for the authorized user.
     *
     * @returns GetConsentsResponse A list of consents for the authorized user.
     *
     * @throws ApiError
     */
    public static getPublicConsents({
        isJunior,
        isReadOnly,
        isSilent,
    }: {
        /**
         * Filter for consents targeting Junior. Possible values:
         * * `true` - only consents that have the Junior flag will be returned
         * * `false` - only consents that don't have the Junior flag will be returned, so only consents for the authorized user
         * * not provided - all consents will be returned, regardless of the Junior flag
         *
         */
        isJunior?: boolean,
        /**
         * Filter for consents by presence of the `readOnly` flag. Possible values:
         * * `true` - only consents that have the `readOnly` flag will be returned
         * * `false` - only consents that don't have the `readOnly` flag will be returned
         * * not provided - all consents will be returned, regardless of the `readOnly` flag
         *
         */
        isReadOnly?: boolean,
        /**
         * Filter for consents by the presence of the `silent` flag. Possible values:
         * * `true` - only consents that have the `silent` flag will be returned
         * * `false` - only consents that don't have the `silent` flag will be returned
         * * not provided - all consents will be returned, regardless of the `silent` flag
         *
         */
        isSilent?: boolean
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static getPublicConsents({
        isJunior,
        isReadOnly,
        isSilent,
    }: {
        /**
         * Filter for consents targeting Junior. Possible values:
         * * `true` - only consents that have the Junior flag will be returned
         * * `false` - only consents that don't have the Junior flag will be returned, so only consents for the authorized user
         * * not provided - all consents will be returned, regardless of the Junior flag
         *
         */
        isJunior?: boolean,
        /**
         * Filter for consents by presence of the `readOnly` flag. Possible values:
         * * `true` - only consents that have the `readOnly` flag will be returned
         * * `false` - only consents that don't have the `readOnly` flag will be returned
         * * not provided - all consents will be returned, regardless of the `readOnly` flag
         *
         */
        isReadOnly?: boolean,
        /**
         * Filter for consents by the presence of the `silent` flag. Possible values:
         * * `true` - only consents that have the `silent` flag will be returned
         * * `false` - only consents that don't have the `silent` flag will be returned
         * * not provided - all consents will be returned, regardless of the `silent` flag
         *
         */
        isSilent?: boolean
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<GetConsentsResponse>;
    public static getPublicConsents({
        isJunior,
        isReadOnly,
        isSilent
    }: {
        /**
         * Filter for consents targeting Junior. Possible values:
         * * `true` - only consents that have the Junior flag will be returned
         * * `false` - only consents that don't have the Junior flag will be returned, so only consents for the authorized user
         * * not provided - all consents will be returned, regardless of the Junior flag
         *
         */
        isJunior?: boolean,
        /**
         * Filter for consents by presence of the `readOnly` flag. Possible values:
         * * `true` - only consents that have the `readOnly` flag will be returned
         * * `false` - only consents that don't have the `readOnly` flag will be returned
         * * not provided - all consents will be returned, regardless of the `readOnly` flag
         *
         */
        isReadOnly?: boolean,
        /**
         * Filter for consents by the presence of the `silent` flag. Possible values:
         * * `true` - only consents that have the `silent` flag will be returned
         * * `false` - only consents that don't have the `silent` flag will be returned
         * * not provided - all consents will be returned, regardless of the `silent` flag
         *
         */
        isSilent?: boolean,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'GET',
            url: '/public/consents',
            query: {
                'isJunior': isJunior,
                'isReadOnly': isReadOnly,
                'isSilent': isSilent,
            },
        });
    }

    /**
     * Get a single consent.
     * Get a single consent for the authorized user.
     *
     * @returns GetConsentResponse A single consent for the authorized user.
     *
     * @throws ApiError
     */
    public static getPublicConsentsById({
        id,
    }: {
        /**
         * The `id` of the consent.
         *
         */
        id: string
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static getPublicConsentsById({
        id,
    }: {
        /**
         * The `id` of the consent.
         *
         */
        id: string
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<GetConsentResponse>;
    public static getPublicConsentsById({
        id
    }: {
        /**
         * The `id` of the consent.
         *
         */
        id: string,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'GET',
            url: '/public/consents/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Update a consent.
     * Update a consent for the authorized user.
     *
     * @returns PutConsentResponse The response from the update consent call for the authorized user.
     * The `signInfo` property is present only if the consent needs to be signed by the authorized user.
     *
     * @throws ApiError
     */
    public static putPublicConsents({
        id,
        requestBody,
    }: {
        /**
         * The `id` of the consent.
         *
         */
        id: string,
        requestBody?: UpdateConsent
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static putPublicConsents({
        id,
        requestBody,
    }: {
        /**
         * The `id` of the consent.
         *
         */
        id: string,
        requestBody?: UpdateConsent
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<PutConsentResponse>;
    public static putPublicConsents({
        id,
        requestBody
    }: {
        /**
         * The `id` of the consent.
         *
         */
        id: string,
        requestBody?: UpdateConsent,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'PUT',
            url: '/public/consents/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
